import { config } from '../config/config';

function retrieveCookie(name, cookie = document.cookie) {

    if (name === config.authentication.authenticationCookie) {
      const token = localStorage.getItem(config.authentication.authenticationCookie);
      if (!!token) return token;
    }

    const value = '; ' + cookie;
    const parts = value.split('; ' + name + '=');

    if (parts.length === 2) {
        const response = parts.pop().split(';').shift();
        return response;
    }
    return null;
}

function setAuthCookie(value) {
    localStorage.setItem(config.authentication.authenticationCookie, value);
}

function deleteAuthCookie() {
    document.cookie = config.authentication.authenticationCookie + '=; domain=.gm.com; path=/; expires=-1';
    localStorage.removeItem(config.authentication.authenticationCookie);
}

export const cgpCookieHelper = {
    retrieveCookie: retrieveCookie,
    setAuthCookie: setAuthCookie,
    deleteAuthCookie: deleteAuthCookie
};
